import { useTranslation } from 'next-i18next'
import parse from 'html-react-parser'

import { css } from '@emotion/react'

import CustomReveal from '@/components/common/CustomReveal'
import Title from '@/components/common/Title'
import ButtonScroll from '@/components/common/ButtonScroll'
import { mediaUp, mediaDown } from '@/styles/media'
import { Grid, mediaColumns } from '@/styles/grid'
import { colors } from '@/styles/theme'
import { Text1Styles } from '@/styles/typography'

function KnowSection() {
  const { t } = useTranslation('landing')

  return (
    <section css={container} id="know-section">
      <CustomReveal cascade>
        <Grid center>
          <Title text={t('saudiExpo.know.title')} css={title} />
          <div css={columnLeft}>
            <div css={imageBackground}>
              <img
                src={
                  'https://cdn.naviparking.com/digital_parking/img/saudiExpo-caseStudy.webp'
                }
              />
            </div>
          </div>
          <div css={columnRight}>
            <div css={description}>
              {parse(t('saudiExpo.know.description'))}
            </div>
            <ul css={list}>
              {Array.isArray(
                t('saudiExpo.know.list', { returnObjects: true })
              ) &&
                t('saudiExpo.know.list', { returnObjects: true }).map(
                  (el: string, index: number) => (
                    <li css={listItem} key={index}>
                      {parse(el)}
                    </li>
                  )
                )}
            </ul>
            <ButtonScroll
              anchor="register-section"
              text={t('button.getCaseStudy')}
            />
          </div>
        </Grid>
      </CustomReveal>
    </section>
  )
}

const container = css`
  ${Text1Styles};
  overflow: hidden;
  padding: 40px 0 60px;

  ${mediaUp('lg')} {
    padding: 80px 0 120px;
  }
`

const title = css`
  ${mediaColumns({ xs: [12, 0] })};
  margin-bottom: 40px;

  ${mediaUp('lg')} {
    margin-bottom: 80px;
  }
`

const columnLeft = css`
  ${mediaColumns({ xs: [12, 0], md: [6, 0] })};

  ${mediaDown('md')} {
    margin-bottom: 20px;
  }
`

const columnRight = css`
  ${mediaColumns({ xs: [12, 0], md: [6, 6] })};

  ${mediaUp('lg')} {
    padding: 0 60px;
  }
`

const imageBackground = css`
  position: relative;
  z-index: 1;

  ${mediaUp('md')} {
    padding: 0 40px;
  }

  img {
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
`

const description = css`
  p {
    margin-bottom: 18px;

    ${mediaUp('lg')} {
      margin-bottom: 30px;
    }
  }
`

const list = css`
  list-style: none;
  margin-bottom: 40px;

  ${mediaUp('lg')} {
    margin-bottom: 60px;
  }
`

const listItem = css`
  position: relative;
  margin-top: 10px;
  padding-inline-start: 27px;

  ${mediaUp('lg')} {
    padding-inline-start: 54px;
  }

  &::before {
    content: '';
    position: absolute;
    background-color: ${colors.greenishCyan};
    left: 0;
    top: 0.45em;
    width: 18px;
    height: 5px;
    border-radius: 5px;

    ${mediaUp('lg')} {
      width: 34px;
      height: 8px;
      border-radius: 8px;
    }

    html[lang^='ar'] & {
      right: 0;
      left: unset;
    }
  }

  ${mediaUp('lg')} {
    margin-top: 20px;
  }
`

export default KnowSection
